import React from "react";
import { startCheckout } from "../stripeClient";

const PLANS = [
  { key_monthly:"solo_monthly",   key_annual:"solo_annual",   name:"Solo",   price_m:29,  price_a:23,  channels:1,  credits:100,  color:"#2B5EA7" },
  { key_monthly:"pro_monthly",    key_annual:"pro_annual",    name:"Pro",    price_m:49,  price_a:39,  channels:2,  credits:250,  color:"#C9A227", featured:true },
  { key_monthly:"agency_monthly", key_annual:"agency_annual", name:"Agency", price_m:99,  price_a:79,  channels:10, credits:1000, color:"#5A6A7E" },
];

const REASON_COPY = {
  no_credits: {
    title: "OUT OF AI CREDITS",
    sub: "You've used all your AI credits for this billing period.",
    icon: "⬡",
    color: "#D93025",
  },
  free_tier: {
    title: "UPGRADE TO UNLOCK",
    sub: "This feature requires a paid plan.",
    icon: "◈",
    color: "#C9A227",
  },
  multi_channel: {
    title: "MULTI-CHANNEL REQUIRES PRO",
    sub: "Add more YouTube channels with a Pro or Agency plan.",
    icon: "◎",
    color: "#2B5EA7",
  },
  team_access: {
    title: "TEAM ACCESS REQUIRES PRO",
    sub: "Invite team members with a Pro or Agency plan.",
    icon: "◎",
    color: "#2B5EA7",
  },
};

export default function UpgradeModal({ reason = "free_tier", onClose }) {
  const [loading, setLoading] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [annual, setAnnual] = React.useState(false); // eslint-disable-line no-unused-vars
  const copy = REASON_COPY[reason] || REASON_COPY.free_tier;

  const handleUpgrade = async (p) => {
    setLoading(p.name);
    setError(null);
    try {
      await startCheckout(annual ? p.key_annual : p.key_monthly);
    } catch(e) {
      setError(e.message);
      setLoading(null);
    }
  };

  const s = {
    overlay: {
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1000, padding: 20,
    },
    modal: {
      background: "#080C12", border: "1px solid #1A2940",
      borderRadius: 10, width: "100%", maxWidth: 560,
      overflow: "hidden",
    },
    header: {
      padding: "24px 24px 20px",
      borderBottom: "1px solid #1A2940",
      textAlign: "center",
    },
    icon: {
      fontSize: 36, marginBottom: 10, color: copy.color,
    },
    title: {
      fontFamily: "Impact, 'Arial Black', sans-serif",
      fontSize: 22, letterSpacing: "0.08em",
      color: "#E8EBF0", marginBottom: 6,
    },
    sub: { fontSize: 13, color: "#5A6A7E", lineHeight: 1.6 },
    plans: { padding: 20, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 },
    plansM: { padding: 20, display: "grid", gridTemplateColumns: "1fr", gap: 10 },
    plan: (featured) => ({
      background: featured ? "rgba(201,162,39,0.06)" : "#0D1825",
      border: `1px solid ${featured ? "#C9A227" : "#1A2940"}`,
      borderRadius: 8, padding: 14, textAlign: "center",
    }),
    planName: { fontSize: 12, fontWeight: 700, color: "#E8EBF0", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 4 },
    planPrice: { fontFamily: "Impact, 'Arial Black', sans-serif", fontSize: 28, color: "#C9A227", lineHeight: 1 },
    planPeriod: { fontSize: 10, color: "#5A6A7E", marginBottom: 10 },
    planDetail: { fontSize: 11, color: "#5A6A7E", marginBottom: 12, lineHeight: 1.5 },
    btn: (featured) => ({
      width: "100%", padding: "8px 0",
      background: featured ? "#C9A227" : "transparent",
      border: `1px solid ${featured ? "#C9A227" : "#1A2940"}`,
      borderRadius: 4, color: featured ? "#080C12" : "#5A6A7E",
      fontFamily: "inherit", fontSize: 11, fontWeight: 700,
      textTransform: "uppercase", letterSpacing: "0.08em",
      cursor: "pointer",
    }),
    footer: {
      padding: "12px 24px", borderTop: "1px solid #1A2940",
      display: "flex", justifyContent: "space-between", alignItems: "center",
    },
  };

  return (
    <div style={s.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={s.modal}>
        <div style={{ height: 3, background: "#D93025" }} />

        <div style={s.header}>
          <div style={s.icon}>{copy.icon}</div>
          <div style={s.title}>{copy.title}</div>
          <div style={s.sub}>{copy.sub}</div>
        </div>

        {error && (
          <div style={{ margin: "0 20px", padding: "10px 14px", background: "rgba(217,48,37,0.1)", border: "1px solid #D93025", borderRadius: 6, fontSize: 13, color: "#ff6b6b" }}>
            {error}
          </div>
        )}

        <div style={s.plans}>
          {PLANS.map(p => (
            <div key={p.key} style={s.plan(p.featured)}>
              <div style={s.planName}>{p.name}</div>
              <div style={s.planPrice}>${p.price}</div>
              <div style={s.planPeriod}>/month</div>
              <div style={s.planDetail}>
                {p.channels} channel{p.channels > 1 ? "s" : ""}<br/>
                {p.credits} AI credits
              </div>
              <button
                style={s.btn(p.featured)}
                disabled={!!loading}
                onClick={() => handleUpgrade(p)}
              >
                {loading === p.name ? "Loading..." : "Upgrade →"}
              </button>
            </div>
          ))}
        </div>

        <div style={s.footer}>
          <div style={{ fontSize: 11, color: "#5A6A7E" }}>
            Secure checkout · Cancel anytime
          </div>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", color: "#5A6A7E", fontFamily: "inherit", fontSize: 12, cursor: "pointer" }}
          >
            Maybe later
          </button>
        </div>

        <div style={{ height: 3, background: "#C9A227" }} />
      </div>
    </div>
  );
}
